













import { Component, Inject, Mixins } from "vue-property-decorator";
import Context from "@/mixins/context";
import {
  IInvoiceProvider,
  IInvoiceProviderMethods
} from "@/models/providers/invoice";

@Component
export default class CreditNoteActions extends Mixins(Context) {
  @Inject({ from: "invoiceProvider" })
  public readonly $invoiceProvider!: () => IInvoiceProvider;
  @Inject({ from: "invoiceProviderMethods" })
  public readonly $invoiceMethods!: IInvoiceProviderMethods;

  public get $invoice() {
    return this.$invoiceProvider();
  }

  public get actions() {
    return [
      {
        label: this.$t("_action.send_email"),
        method: this.$invoiceMethods.openSendEmailModal,
        if: () => true
      }
    ];
  }

  public get availableActions() {
    return this.$_.filter(this.actions, action => action.if);
  }
}
